export const utilityClassNames = {
  animalsList: "animals",
};
